import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const uploadFileRequest = createAction('files/uploadFileRequest');

const filesSlice = createSlice({
    name: 'files',
    initialState,
    reducers: {
        addFile: (state, action) => {
            const { key, file } = action.payload;
            if (!state[key]) {
                state[key] = { files: [] };
            }
            state[key].files.push(file);
            // console.log('Files:', JSON.stringify(state[key].files));
        },
        removeFile: (state, action) => {
            const { key, idx } = action.payload;
            if (state[key] && state[key].files) {
                state[key].files.splice(idx, 1);
            }
            // console.log('Files:', JSON.stringify(state[key].files));
        },
        clearFiles: (state, action) => {
            const { key } = action.payload;
            if (state[key]) {
                state[key].files = [];
                state[key].existingImages = [];
                state[key].removedImageUrls = [];
            }
        },
        updateFileUrl: (state, action) => {
            const { key, idx, fileURL } = action.payload;
            if (state[key] && state[key].files && state[key].files[idx]) {
                state[key].files[idx].fileURL = fileURL;
            }
            // console.log('Updated Files:', JSON.stringify(state[key].files));
        },
        setFileError: (state, action) => {
            const { key, error } = action.payload;
            if (state[key]) {
                state[key].error = error;
            }
        },

        addRemovedImageUrl: (state, action) => {
            const { key, imageUrl } = action.payload;
            if (!state[key]) {
                state[key] = { files: [], existingImages: [], removedImageUrls: [] };
            }
            if (!state[key].removedImageUrls?.includes(imageUrl)) {
                state[key].removedImageUrls?.push(imageUrl);
            }
            // console.log('Added removed image URL:', imageUrl);
        },

        clearImageChanges: (state, action) => {
            const { key } = action.payload;
            if (state[key]) {
                state[key].files = [];
                state[key].removedImageUrls = [];
            }
        },
    },
});

export const {
    addFile,
    removeFile,
    clearFiles,
    updateFileUrl,
    setFileError,
    addRemovedImageUrl,
    clearImageChanges
} = filesSlice.actions;

export default filesSlice.reducer;
